export const signUpEN = {
  header: 'Check in',
  register: 'REGISTER'
}
